<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <router-link
                class="btn btn-outline-primary btn-sm mr-3"
                :to="{ name: 'all-services-cn' }"
                ><i class="fa fa-chevron-left mr-2"></i
                >{{ $t("message.back") }}</router-link
              >
              <h4 class="card-title">
                {{ $t("message.find_partner.common_info_cn") }}
              </h4>
            </div>
            <pdf
              v-if="searchComplete"
              :user_id="0"
              :document="pdf_document"
              :doc_additional="{ request: keyWord }"
              :goods="[]"
              :doc_id="0"
              source="company-info-service-cn"
            ></pdf>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <br />
                <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                  <input
                    type="text"
                    class="form-control"
                    id="keyword"
                    v-model="keyWord"
                    :placeholder="$t('message.find_partner.search_keyword')"
                    autocomplete="off"
                    style="cursor: auto"
                  />
                  <label for="keyword" class="form-label-group-label">{{
                    $t("message.find_partner.search_keyword")
                  }}</label>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <button
                  :class="[
                    'btn',
                    'btn-success',
                    'btn-round',
                    'btn-sm',
                    'position-relative',
                  ]"
                  @click="searchCompanyInfo"
                  id="init_search_china"
                >
                  {{ $t("message.find_partner.search_button") }}
                </button>
              </div>
            </div>
            <br />
            <div
              v-if="!searchComplete && loading > 0"
              style="position: relative; height: 100px"
            >
              <div class="loading"></div>
            </div>
            <div v-if="searchComplete" class="table-responsive">
              <div
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                <h4>{{ $t("message.find_partner.common_info_cn") }}</h4>
              </div>
              <br />
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">
                      {{ $t("message.find_partner.table_field") }}
                    </th>
                    <th scope="col">
                      {{ $t("message.find_partner.table_value") }}
                    </th>
                    <th scope="col">
                      {{ $t("message.find_partner.table_value_cn") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in service_info">
                    <td>{{ value[0] }}</td>
                    <td>{{ value[2] }}</td>
                    <td>{{ value[1] }}</td>
                  </tr>
                </tbody>
              </table>

              <div v-if="response_info.Area">
                <div
                  class="card-header card-header-primary negative rounded-0 blue-grad w-50"
                >
                  <h4>{{ $t("message.find_partner.area_table") }}</h4>
                </div>
                <br />
                <b-table :fields="object_table_fields" :items="areaList">
                  <template v-slot:cell(Key)="data">
                    {{ $t("message.find_partner.area_list_" + data.value) }}
                  </template>
                </b-table>
              </div>

              <div v-if="response_info.Industry">
                <div
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  <h4>{{ $t("message.find_partner.industry_table") }}</h4>
                </div>
                <br />
                <b-table :fields="object_table_fields" :items="industryList">
                  <template v-slot:cell(Key)="data">
                    {{ $t("message.find_partner.industry_list_" + data.value) }}
                  </template>
                </b-table>
              </div>
              <div v-if="response_info.RevokeInfo">
                <div
                  class="card-header card-header-primary negative blue-grad w-50"
                >
                  <h4>{{ $t("message.find_partner.revoke_info_table") }}</h4>
                </div>
                <br />
                <b-table :fields="object_table_fields" :items="revokeInfoList">
                  <template v-slot:cell(Key)="data">
                    {{
                      $t("message.find_partner.revoke_info_list_" + data.value)
                    }}
                  </template>
                </b-table>
              </div>
              <div v-if="response_info.ParentInfo">
                <div
                  class="card-header card-header-primary negative blue-grad w-50"
                >
                  <h4>{{ $t("message.find_partner.parent_info_table") }}</h4>
                </div>
                <br />
                <b-table :fields="object_table_fields" :items="parentInfoList">
                  <template v-slot:cell(Key)="data">
                    {{
                      $t("message.find_partner.parent_info_list_" + data.value)
                    }}
                  </template>
                </b-table>
              </div>

              <div v-if="UsedNameList.length > 0">
                <div
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  <h4>
                    {{ $t("message.find_partner.common_info_name_list") }}
                  </h4>
                </div>
                <br />
                <b-table :fields="used_name_list_fields" :items="UsedNameList">
                </b-table>
              </div>

              <div v-if="ShareHolderList.length > 0">
                <div
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  <h4>
                    {{
                      $t("message.find_partner.common_info_share_holder_list")
                    }}
                  </h4>
                </div>
                <br />
                <b-table
                  :fields="shareholder_list_fields"
                  :items="ShareHolderList"
                >
                </b-table>
              </div>

              <div v-if="EmployeeList.length > 0">
                <div
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  <h4>
                    {{ $t("message.find_partner.common_info_employee_list") }}
                  </h4>
                </div>
                <br />
                <b-table :fields="employees_list_fields" :items="EmployeeList">
                </b-table>
              </div>

              <div v-if="InvestList.length > 0">
                <div
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  <h4>
                    {{ $t("message.find_partner.common_info_invest_list") }}
                  </h4>
                </div>
                <br />
                <b-table :fields="invest_list_fields" :items="InvestList">
                </b-table>
              </div>

              <div v-if="ChangeList.length > 0">
                <div
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  <h4>
                    {{ $t("message.find_partner.common_info_change_list") }}
                  </h4>
                </div>
                <br />
                <b-table :fields="change_list_fields" :items="ChangeList">
                </b-table>
              </div>

              <div v-if="BranchList.length > 0">
                <div
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  <h4>
                    {{ $t("message.find_partner.common_info_branch_list") }}
                  </h4>
                </div>
                <br />
                <b-table :fields="branch_list_fields" :items="BranchList">
                </b-table>
              </div>

              <div v-if="MoreEmailList.length > 0">
                <div
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  <h4>
                    {{ $t("message.find_partner.common_info_more_email_list") }}
                  </h4>
                </div>
                <br />
                <b-table
                  :fields="more_email_list_fields"
                  :items="MoreEmailList"
                >
                </b-table>
              </div>

              <div v-if="EntTagList.length > 0">
                <div
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  <h4>
                    {{ $t("message.find_partner.common_info_ent_tag_list") }}
                  </h4>
                </div>
                <br />
                <b-table :fields="ent_tag_list_fields" :items="EntTagList">
                </b-table>
              </div>
            </div>
            <div v-if="searchComplete && no_results">
              <div class="p-3 text-center">
                {{
                  $t("message.find_partner.no_results").replace(
                    "[company]",
                    keyWord,
                  )
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      loading: 0,
      no_result: false,
      current_tab: 0,
      response_info: {},
      service_info: {},
      service_info_objects: {},
      keyWord: "",
      searchComplete: false,
      areaSearchComplete: false,
      industrySearchComplete: false,
      revokeInfoSearchComplete: false,
      parentInfoSearchComplete: false,
      areaList: [],
      industryList: [],
      revokeInfoList: [],
      parentInfoList: [],

      UsedNameList: [],
      ShareHolderList: [],
      EmployeeList: [],
      InvestList: [],
      ChangeList: [],
      BranchList: [],
      MoreEmailList: [],
      EntTagList: [],
      pdf_document: {},
      used_name_list_fields: [
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_name_list_name"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.find_partner.common_info_name_list_date"),
        },
      ],
      shareholder_list_fields: [
        {
          key: "KeyNo",
          label: this.$t("message.find_partner.common_info_share_holder_KeyNo"),
        },
        {
          key: "StockName",
          label: this.$t(
            "message.find_partner.common_info_share_holder_StockName",
          ),
        },
      ],
      employees_list_fields: [
        {
          key: "KeyNo",
          label: this.$t("message.find_partner.common_info_employee_KeyNo"),
        },
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_employee_Name"),
        },
        {
          key: "Job",
          label: this.$t("message.find_partner.common_info_employee_Job"),
        },
      ],
      invest_list_fields: [
        {
          key: "KeyNo",
          label: this.$t("message.find_partner.common_info_invest_list_KeyNo"),
        },
        {
          key: "RegistCapi",
          label: this.$t(
            "message.find_partner.common_info_invest_list_RegistCapi",
          ),
        },
        {
          key: "StartDate",
          label: this.$t(
            "message.find_partner.common_info_invest_list_StartDate",
          ),
        },
        {
          key: "Status",
          label: this.$t("message.find_partner.common_info_invest_list_Status"),
        },
        {
          key: "OperName",
          label: this.$t(
            "message.find_partner.common_info_invest_list_OperName",
          ),
        },
      ],
      change_list_fields: [
        {
          key: "ProjectName",
          label: this.$t(
            "message.find_partner.common_info_change_list_ProjectName",
          ),
        },
        {
          key: "BeforeList",
          label: this.$t(
            "message.find_partner.common_info_change_list_BeforeList",
          ),
        },
        {
          key: "AfterList",
          label: this.$t(
            "message.find_partner.common_info_change_list_AfterList",
          ),
        },
        {
          key: "ChangeDate",
          label: this.$t(
            "message.find_partner.common_info_change_list_ChangeDate",
          ),
        },
      ],
      branch_list_fields: [
        {
          key: "KeyNo",
          label: this.$t("message.find_partner.common_info_branch_list_KeyNo"),
        },
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_branch_list_Name"),
        },
        {
          key: "DirectorName",
          label: this.$t(
            "message.find_partner.common_info_branch_list_DirectorName",
          ),
        },
        {
          key: "Status",
          label: this.$t("message.find_partner.common_info_branch_list_Status"),
        },
      ],
      more_email_list_fields: [
        {
          key: "Source",
          label: this.$t(
            "message.find_partner.common_info_more_email_list_Source",
          ),
        },
        {
          key: "Value",
          label: this.$t(
            "message.find_partner.common_info_more_email_list_Value",
          ),
        },
      ],
      more_tel_list_fields: [
        {
          key: "Source",
          label: this.$t(
            "message.find_partner.common_info_more_tel_list_Source",
          ),
        },
        {
          key: "Value",
          label: this.$t(
            "message.find_partner.common_info_more_tel_list_Value",
          ),
        },
      ],
      ent_tag_list_fields: [
        {
          key: "Type",
          label: this.$t("message.find_partner.common_info_ent_tag_list_Type"),
        },
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_ent_tag_list_Name"),
        },
      ],
      object_table_fields: [
        {
          key: "Key",
          label: this.$t("message.find_partner.table_field"),
        },
        {
          key: "Translated",
          label: this.$t("message.find_partner.table_value"),
        },
        {
          key: "Original",
          label: this.$t("message.find_partner.table_value_cn"),
        },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    translateText(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        axios
          .get(
            window.base +
              "/library/TranslateNext?text=" +
              text +
              "&source=zh&target=" +
              locale,
          )
          .then((response) => {
            return response.data.translation;
          });
      } else {
        return text;
      }
    },
    translateTextArray(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
            "/library/TranslateNextArray?source=zh&target=" +
            locale,
          text,
        );
      }
    },
    // formats table data with translations
    formatObjectTables(object, list, complete) {
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        this.translateTextArray(values)
          .then((res) => {
            res.data.forEach((t, i) => {
              list.push({
                Key: keys[i],
                Translated: JSON.parse(t).translation,
                Original: values[i],
              });
            });
            complete = true;
            console.log("loading change", this.loading - 1);
            this.loading--;
          })
          .catch(() => {
            console.log("error translating...", this.loading - 1);
            this.loading--;
          });
      }
    },
    formatArrayObjectTables(object, list) {
      if (object.length > 0) {
        object.forEach((obj, i) => {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          this.translateTextArray(values)
            .then((res) => {
              var translated = {};
              for (let j = 0; j < res.data.length; j++) {
                translated[keys[j]] = JSON.parse(res.data[j]).translation;
                console.log("translated");
                console.log(translated);
              }
              list.push(translated);
            })
            .catch(() => {
              console.log("error translating...");
            });
        });
        console.log("loading change", this.loading - 1);
        this.loading--;
      }
    },
    searchCompanyInfo() {
      axios
        .get(window.base + "/admin/GetBillingServiceInfo?code=430")
        .then((response) => {
          this.$bvModal
            .msgBoxConfirm(
              this.$t("message.find_partner.cn_company_info_check_alert") +
                " " +
                response.data.billing_service_price +
                " " +
                response.data.billing_service_cur,
              {
                title: this.$t("message.confirm"),
                size: "md",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: this.$t("message.yes"),
                cancelTitle: this.$t("message.no"),
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              },
            )
            .then((value) => {
              if (value) {
                this.loading = 14;
                this.searchComplete = false;
                axios
                  .get(
                    "https://attistrade.cn/library/openAPIQCC?keyWord=" +
                      this.keyWord,
                  )
                  .then((response) => {
                    this.loading--;
                    if (response.data.Result == null) {
                      this.search_complete = true;
                      this.loading = 0;
                      this.no_result = true;
                      return;
                    }
                    this.no_result = false;
                    var tmp_response_info = response.data.Result;

                    // transform change list data
                    if (tmp_response_info.ChangeList.length > 0) {
                      tmp_response_info.ChangeList.forEach((chg) => {
                        chg.BeforeList = chg.BeforeList.join(",");
                        chg.AfterList = chg.AfterList.join(",");
                      });
                    }

                    var tmp_service_info = Object.entries(response.data.Result);
                    //var tmp_service_info_objects = tmp_service_info.filter(item => typeof item[1] === 'object' && item[1] !== null && !_.isArray(item[1]));
                    tmp_service_info = tmp_service_info.filter(
                      (item) =>
                        typeof item[1] !== "object" && !_.isArray(item[1]),
                    );

                    // Translating packages of text (columns of tables)
                    var service_to_translate = [];
                    tmp_service_info.forEach(([key, value]) => {
                      service_to_translate.push(value);
                    });

                    this.translateTextArray(service_to_translate).then(
                      (res) => {
                        this.loading--;
                        this.searchComplete = true;
                        for (let i = 0; i < res.data.length; i++) {
                          tmp_service_info[i].push(
                            JSON.parse(res.data[i]).translation,
                          );
                        }
                        this.service_info = tmp_service_info;
                      },
                    );

                    //Formating object tables data
                    this.formatObjectTables(
                      tmp_response_info.Area,
                      this.areaList,
                      this.areaSearchComplete,
                    );
                    this.formatObjectTables(
                      tmp_response_info.Industry,
                      this.industryList,
                      this.industrySearchComplete,
                    );
                    this.formatObjectTables(
                      tmp_response_info.RevokeInfo,
                      this.revokeInfoList,
                      this.revokeInfoSearchComplete,
                    );
                    this.formatObjectTables(
                      tmp_response_info.ParentInfo,
                      this.parentInfoList,
                      this.parentInfoSearchComplete,
                    );

                    //Formating object array tables
                    this.formatArrayObjectTables(
                      tmp_response_info.EntTagList,
                      this.EntTagList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.ChangeList,
                      this.ChangeList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.UsedNameList,
                      this.UsedNameList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.ShareHolderList,
                      this.ShareHolderList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.EmployeeList,
                      this.EmployeeList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.InvestList,
                      this.InvestList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.BranchList,
                      this.BranchList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.MoreEmailList,
                      this.MoreEmailList,
                    );

                    this.response_info = tmp_response_info;

                    // adding data for pdf
                    this.pdf_document.response_info = tmp_response_info;
                    this.pdf_document.service_info =
                      this.service_info || tmp_service_info;
                    this.pdf_document.areaList = this.areaList;
                    this.pdf_document.industryList = this.industryList;
                    this.pdf_document.revokeInfoList = this.revokeInfoList;
                    this.pdf_document.parentInfoList = this.parentInfoList;
                    this.pdf_document.EntTagList = this.EntTagList;
                    this.pdf_document.ChangeList = this.ChangeList;
                    this.pdf_document.UsedNameList = this.UsedNameList;
                    this.pdf_document.ShareHolderList = this.ShareHolderList;
                    this.pdf_document.EmployeeList = this.EmployeeList;
                    this.pdf_document.InvestList = this.InvestList;
                    this.pdf_document.BranchList = this.BranchList;
                    this.pdf_document.MoreEmailList = this.MoreEmailList;
                  })
                  .catch(() => {
                    let response = {
                      data: {
                        Status: "200",
                        Message: "【有效请求】查询成功",
                        OrderNumber: "ECICOMPLEMENT2022101117013421721731",
                        Result: {
                          KeyNo: "b0db038784ed3748b7fd96e1fcc82f0c",
                          Name: "中国石油吉林通化销售分公司集安经营处太平加油站",
                          OperId: "p1bb8d59c3ef73e64457b31387479dda",
                          OperName: "金洪林",
                          Status: "存续（在营、开业、在册）",
                          StartDate: "2005-10-27",
                          RegistCapi: "",
                          RecCap: null,
                          CheckDate: "2014-11-04",
                          OrgNo: "73704768-X",
                          No: "220582000008521",
                          CreditCode: "9122058273704768XJ",
                          EconKind: "股份有限公司分公司（国有控股）",
                          TermStart: "2005-10-27",
                          TermEnd: "",
                          TaxpayerType: null,
                          BelongOrg: "集安市市场监督管理局",
                          PersonScope: "",
                          InsuredCount: "0",
                          EnglishName: "China National Petroleum Corporation",
                          IXCode: "",
                          Address: "集丹公路25公里",
                          Scope:
                            "乙醇汽油、柴油、润滑油、烟、预包装食品兼散装食品、乳制品（不含婴幼儿配方乳粉）、五金电器、日用百货、办公用品、汽车零配件、农用物资（不含农药）销售；汽车换机油、刷车服务。（依法须经批准的项目，经相关部门批准后方可开展经营活动）",
                          IsOnStock: "0",
                          StockNumber: "",
                          StockType: "",
                          ImageUrl:
                            "https://image.qcc.com/auto/b0db038784ed3748b7fd96e1fcc82f0c.jpg?x-oss-process=style/logo_120",
                          PhoneNumber: "0435-6260003",
                          Email: "zyjajyc@163.com",
                          WebSiteUrl: "",
                          EntNature: "0",
                          Area: {
                            Province: "吉林省",
                            City: "通化市",
                            County: "集安市",
                          },
                          AreaCode: "220582",
                          Industry: {
                            IndustryCode: "F",
                            Industry: "批发和零售业",
                            SubIndustryCode: "52",
                            SubIndustry: "零售业",
                            MiddleCategoryCode: "529",
                            MiddleCategory: "货摊、无店铺及其他零售业",
                            SmallCategoryCode: "5299",
                            SmallCategory: "其他未列明零售业",
                          },
                          UsedNameList: [],
                          RevokeInfo: null,
                          ShareHolderList: [],
                          EmployeeList: [],
                          InvestList: [],
                          ChangeList: [
                            {
                              ProjectName: "经营范围变更",
                              BeforeList: [
                                "石油制品、烟酒（凭专卖许可证经营）、五金电器、日用百货、汽车零配件、润滑油销售、汽车换机油、刷车",
                              ],
                              AfterList: [
                                "乙醇汽油、柴油、润滑油、烟、（凭许可证经营）、预包装食品兼散装食品、乳制品（不含婴幼儿配方乳粉）、五金电器、日用百货、办公用品、汽车零配件、农用物资（不含农药）销售",
                                "汽车换机油、刷车（食品流通许可证有效期至2015年07月08日）***",
                              ],
                              ChangeDate: "2012-07-11",
                            },
                          ],
                          ControlList: null,
                          BranchList: [],
                          ParentInfo: null,
                          MoreEmailList: [],
                          MoreTelList: [
                            { Source: "2013年报", Value: "0435-6260008" },
                          ],
                          EntTagList: [
                            { Type: "901", Name: "经营异常" },
                            { Type: "505", Name: "小微企业" },
                          ],
                        },
                      },
                    };

                    this.loading--;

                    var tmp_response_info = response.data.Result;

                    // transform change list data
                    if (tmp_response_info.ChangeList.length > 0) {
                      tmp_response_info.ChangeList.forEach((chg) => {
                        chg.BeforeList = chg.BeforeList.join(",");
                        chg.AfterList = chg.AfterList.join(",");
                      });
                    }

                    var tmp_service_info = Object.entries(response.data.Result);
                    //var tmp_service_info_objects = tmp_service_info.filter(item => typeof item[1] === 'object' && item[1] !== null && !_.isArray(item[1]));
                    tmp_service_info = tmp_service_info.filter(
                      (item) =>
                        typeof item[1] !== "object" && !_.isArray(item[1]),
                    );

                    // Translating packages of text (columns of tables)
                    var service_to_translate = [];
                    tmp_service_info.forEach(([key, value]) => {
                      service_to_translate.push(value);
                    });

                    this.translateTextArray(service_to_translate).then(
                      (res) => {
                        this.loading--;
                        this.searchComplete = true;
                        for (let i = 0; i < res.data.length; i++) {
                          tmp_service_info[i].push(
                            JSON.parse(res.data[i]).translation,
                          );
                        }
                        this.service_info = tmp_service_info;
                      },
                    );

                    //Formating object tables data
                    this.formatObjectTables(
                      tmp_response_info.Area,
                      this.areaList,
                      this.areaSearchComplete,
                    );
                    this.formatObjectTables(
                      tmp_response_info.Industry,
                      this.industryList,
                      this.industrySearchComplete,
                    );
                    this.formatObjectTables(
                      tmp_response_info.RevokeInfo,
                      this.revokeInfoList,
                      this.revokeInfoSearchComplete,
                    );
                    this.formatObjectTables(
                      tmp_response_info.ParentInfo,
                      this.parentInfoList,
                      this.parentInfoSearchComplete,
                    );

                    //Formating object array tables
                    this.formatArrayObjectTables(
                      tmp_response_info.EntTagList,
                      this.EntTagList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.ChangeList,
                      this.ChangeList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.UsedNameList,
                      this.UsedNameList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.ShareHolderList,
                      this.ShareHolderList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.EmployeeList,
                      this.EmployeeList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.InvestList,
                      this.InvestList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.BranchList,
                      this.BranchList,
                    );
                    this.formatArrayObjectTables(
                      tmp_response_info.MoreEmailList,
                      this.MoreEmailList,
                    );

                    this.response_info = tmp_response_info;

                    // adding data for pdf
                    this.pdf_document.response_info = tmp_response_info;
                    this.pdf_document.service_info =
                      this.service_info || tmp_service_info;
                    this.pdf_document.areaList = this.areaList;
                    this.pdf_document.industryList = this.industryList;
                    this.pdf_document.revokeInfoList = this.revokeInfoList;
                    this.pdf_document.parentInfoList = this.parentInfoList;
                    this.pdf_document.EntTagList = this.EntTagList;
                    this.pdf_document.ChangeList = this.ChangeList;
                    this.pdf_document.UsedNameList = this.UsedNameList;
                    this.pdf_document.ShareHolderList = this.ShareHolderList;
                    this.pdf_document.EmployeeList = this.EmployeeList;
                    this.pdf_document.InvestList = this.InvestList;
                    this.pdf_document.BranchList = this.BranchList;
                    this.pdf_document.MoreEmailList = this.MoreEmailList;
                  });
              }
            });
        });
    },
  },
};
</script>
